<template>
    <kgr-form-scaffold
        :with-primary-buttons="false"
        @backBtnClicked="redirectToOverview"
    >
        <div class="animated fadeIn">
            <div class="kgr-row kgr-text--rightAligned">
                <a
                    class="kgr-button kgr-button--accent"
                    @click="openCreateDialog"
                >
                    {{ $t('Neue Verknüpfung anlegen') }}
                </a>
            </div>
            <table class="kgr-table kgr-table--block kgr-table--striped printable">
                <thead>
                    <tr class="kgr-table__row">
                        <th class="kgr-table__cell kgr-table__cell--headline">
                            {{ $t('Beitrag') }}
                        </th>
                        <th class="kgr-table__cell kgr-table__cell--headline">
                            {{ $t('Verknüpfter Hund') }}
                        </th>
                        <th class="kgr-table__cell kgr-table__cell--headline kgr-table__cell--actions kgr-hidden-print"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="loading">
                        <td
                            colspan="3"
                            style="text-align: center;"
                        >
                            <kgr-loader />
                        </td>
                    </tr>
                    <tr v-else-if="dogMemberFees.length === 0">
                        <td
                            colspan="3"
                            style="text-align: center;"
                        >
                            {{ $t('dataTable.noData') }}
                        </td>
                    </tr>
                    <template v-else>
                        <tr
                            v-for="fee in dogMemberFees"
                            :key="fee.id"
                            class="kgr-table__row"
                        >
                            <td class="kgr-table__cell">
                                {{ fee.memberClubFee.name }}
                            </td>
                            <td class="kgr-table__cell">
                                {{ fee.dog.name }}
                            </td>
                            <td class="kgr-table__cell kgr-table__cell--actions kgr-hidden-print">
                                <button
                                    :disabled="fee.archived"
                                    class="kgr-table__action"
                                    @click="deleteDogMemberClubFee(fee.id)"
                                >
                                    <kgr-icon
                                        :disabled="fee.archived"
                                        icon-class="delete"
                                    />
                                </button>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
        <kgr-lightbox
            v-if="dogMemberClubFee && showCreateDialog"
            :value="showCreateDialog"
            :headline="$t('Neue Verknüpfung anlegen')"
            scrollable
            @post-input="closeCreateDialog"
        >
            <div style="min-height: 300px;">
                <kgr-form-row
                    :label="$t('Beitrag')"
                    :error="error"
                    field-name="clubFee"
                >
                    <kgr-member-club-fee-select
                        v-model="dogMemberClubFee.memberClubFee"
                        :member-id="id"
                        :excluded-ids="usedFees"
                        hide-label
                    />
                </kgr-form-row>
                <kgr-form-row
                    :label="$t('Hund')"
                    :error="error"
                    field-name="dog"
                >
                    <kgr-member-dog-relation-select
                        v-model="dogMemberClubFee.dog"
                        :member-id="id"
                    />
                </kgr-form-row>
            </div>
            <template #footer>
                <button
                    class="kgr-button"
                    @click="closeCreateDialog"
                >
                    {{ $t('cancel') }}
                </button>
                <button
                    class="kgr-button kgr-button--accent"
                    :disabled="!dogMemberClubFee.dog || !dogMemberClubFee.memberClubFee"
                    @click="createDogMemberClubFee(); closeCreateDialog();"
                >
                    {{ $t('Speichern') }}
                </button>
            </template>
        </kgr-lightbox>
    </kgr-form-scaffold>
</template>

<script>
import DogMemberClubFeeRepository from '../../../js/repository/DogMemberClubFeeRepository.js';
import Error from '../../../js/model/Error.js';
import FormRow from '../../../components/common/form/FormRow.vue';
import FormScaffold from '../../../components/common/form/FormScaffold';
import Icon from '../../../components/common/icon/Icon.vue';
import Lightbox from '../../../components/common/modal/Lightbox.vue';
import Loading from '../../../components/common/Loading.vue';
import MemberClubFeeSelect from '../../../components/common/form/select/MemberClubFeeSelect.vue';
import MemberDogRelationSelect from '../../../components/common/form/select/MemberDogRelationSelect.vue';

export default {
    components: {
        'kgr-icon': Icon,
        'kgr-lightbox': Lightbox,
        'kgr-loader': Loading,
        'kgr-form-scaffold': FormScaffold,
        'kgr-form-row': FormRow,
        'kgr-member-dog-relation-select': MemberDogRelationSelect,
        'kgr-member-club-fee-select': MemberClubFeeSelect,
    },
    props: {
        id: {
            type: Number,
            required: true,
        },
        clubId: {
            type: Number,
            required: true,
        }
    },
    data() {
        return {
            error: new Error(),
            loading: false,
            dogMemberFees: [],
            dogMemberClubFee: null,
            showCreateDialog: false,
        }
    },
    computed: {
        usedFees() {
            return this.dogMemberFees.map((dogMemberFee) => dogMemberFee.memberClubFee.id);
        }
    },
    created() {
        this.loadMemberDogFees();
    },
    methods: {
        initNew() {
            this.dogMemberClubFee = {
                memberClubFee: null,
                dog: null,
            };
        },
        deleteDogMemberClubFee(id) {
            showConfirm(this.$t('Bist du dir sicher?'), this.$t('Willst du die Verknüpfung wirklich löschen?') , () => {
                this.loading = true;
                DogMemberClubFeeRepository.delete(id)
                    .then(() => {
                        this.loadMemberDogFees();
                    })
                    .finally(() => this.loading = false);
            });
        },
        createDogMemberClubFee() {
            this.loading = true;
            DogMemberClubFeeRepository
                .create(this.id, this.dogMemberClubFee.memberClubFee.id, this.dogMemberClubFee.dog.id)
                .then(() => {
                    this.loadMemberDogFees();
                })
                .catch(() => this.loading = false);
            this.initNew();
        },
        loadMemberDogFees() {
            this.loading = true;
            DogMemberClubFeeRepository
                .findByMember(this.id)
                .then(dogMemberFees => {
                    this.dogMemberFees = dogMemberFees;
                    this.loading = false;
                });
        },
        redirectToOverview() {
            window.location = `/backend/clubs/${this.clubId}/members`;
        },
        openCreateDialog() {
            this.initNew();
            this.showCreateDialog = true;
        },
        closeCreateDialog() {
            this.showCreateDialog = false;
            this.dogMemberClubFee = null;
        },
    }
}
</script>
